import i18n from './index.js'
export default {//英语
  translateText: {
    shoppingcart: "Shopping Cart",
    loginorrefisterText: "Login/Sign up",
    logoutText: "Log out",
    personcenterText: "Personal Cente",
    loginorrefisterText: "Login/Sign up",
    placeholderText: "Please select",
    loginText: "Login",
    registerText: "Register",
    emailText: "E-mail",
    pwdText: "Password",
    forgetpwdText: "Forgot your password",
    nameText: "Name",
    surnameText: "Surname",
    mobileText: "Telephone",
    setPwdText: "SetPwd",
    confirmpwdText: "Set password",
    countryText: "Country",
    company: "Company",
    birthday: "birthday",
    yearText: "year",
    mouthText: "mouth",
    dayText: "day",
    confirmpwdText: "Confirm Password",
    agreeText1: "I have read and agree to ",
    agreeText2: "conditions of use ",
    agreeText3: "and",
    agreeText4: " privacy statement",
    agreeText5: " and agree that some of my personal information will be processed offshore in accordance with the Privacy Statement.",
    emailplaceholder: 'Please enter your email address',
    subscribetitleText: 'Subscribe to our newsletter',
    subscribeText: 'Subscribe',
    shareToText: 'Share To',
    shareToText1: 'follow us  on',
    searchText: 'Search',
    couponText: "Discount Coupons",
    subtractmoneyText: "Up to 600 off",
    magnanimitycouponText: "A large number of coupons are waiting for you",
    drawText: "Collect Now",
    discountText: "Super Discount",
    purchaseText: "Buy Now",
    composecouponText: "Combination purchases",
    manyDiscountsText: "Great offers",
    recommendtitleText: "Recommend for you",
    hotsaleproductyitleText: "Hot Product",
    guessLiketitleText: "Guess your favourite",
    NoDataText: "Data not available",
    appraiseText: "Evaluation",
    certificate: "Coupon",
    collectText: "Collection",
    productDetailsText: "Product Details",
    addCartText: "Add to cart",
    enterkeywordsText: "Enter keywords",
    useNowText: "Use now",
    vouchernoText: "Voucher No",
    placeholderyearText: "Select Year",
    placeholdermouthText: "Select Mouth",
    placeholderdayText: "Select Day",
    // 优惠券页面
    breadcrumbItemText1: 'Super',
    breadcrumbItemText2: 'Level',
    breadcrumbItemText3: 'Big',
    breadcrumbItemText4: 'Blessing',
    breadcrumbItemText5: 'Profit',
    magnanimitydrawText: 'A large number of coupons are waiting for you',
    availablecouponstitleText: 'Available Voucher Products',
    drawbtnText: 'Collection',
    universalText: 'Universal across the site',
    useText: 'Use',
    limitText: 'Limit',
    fullText: 'Full',
    subtractText: 'Less',
    // 折扣
    discountitemText1: 'Discounts and special offers',
    discountitemText2: '',
    // 组合
    commoditydiscountitemText1: 'Combine your purchases for great savings',
    commoditydiscountitemText2: '',
    combinedpriceText: 'Combination price',
    economizeText: 'Savings',
    buynowText: "Buy Now",
    // 产品
    ourproductsText: 'Our products',
    productcategoryText: 'Product category',
    recommendtarText: 'Recommend',
    newText: 'New',
    salesvolumetarText: 'Sales',
    pricetarText: 'Price',
    // 博客
    blogmanagementText: "Top Blogs",
    latestblogsText: "Latest Blogs",
    relatedrlogsText: "Related Blogs",
    priceIncreasecommentText: "Price increase comment",
    commentsectionTtxt: "Comment section",
    participatingcommentsText: "Participating Comments",
    // 论坛
    postingText: "Posting",
    topicsText: "Topics",
    replyText: "Reply",
    viewText: "View",
    lastreplyText: "LastReply",
    publishText: "Publish",
    placeholdertypeText: "Please select a category",
    placeholdertitleText: "Please enter a title",
    placeholdercontentsText: "Please enter content",
    fromtopicText: "FromTopic：",
    firstfloor: "1Floor",
    floorText: "Floor",
    fromText: "From：",
    postreplyText: "postReply",
    // 个人中心
    myorderText: "My Order",
    mycommentsText: "My Comments",
    mycollectionText: "My Collection",
    couponText: "Coupon",
    shippingaddressText: "Shipping Address",
    myPostText: "My Post",
    personalinformationText: "Personal Information",
    editText: "Edit",
    // 个人中心 - 我的订单
    myorderText: "My Order",
    mycommentsText: "My Comments",
    mycollectionText: "My Collection",
    couponText: "CouponT",
    shippingaddressText: "Shipping Address",
    myPostText: "My Post",
    personalinformationText: "PersonalInfo",
    editText: "Edit",
    allordersText: "AllOrder",
    unpaidText: "Unpaid",
    shippedText: " shipped",
    receivedText: "Received",
    signedforText: "Signed for",
    rejectionText: "rejection",
    evaluatedText: "Evaluated",
    evaluated1Text: "Evaluated",
    baidText: "To be paid",
    reviewedText: "To be reviewed",
    PaidText: "Paid",
    completedText: "Completed",
    productinfText: "productInfo",
    unitpricethText: "unitPrice",
    quantitythText: "Quantity",
    subtotalText:"subtotal",
    actualpaymentthText: "QctualPayment",
    transactionstatusthText: "TransactionStatus",
    operationthText: "Operation",
    ordernumberText: "OrderNumber",
    orderdetailsText: "OrderDetails",
    cancelorderText: "CancelOrder",
    waitingforpaymentText: "Waiting for payment",
    confirmText: "confirm",
    cancelText: "cancel",
    deleteordertitle: "Are you sure to delete the current order?",
    successfultradeText: "successful Trade",
    paymentText: "payment",
    confirmreceiptText: "Confirm receipt",
    nncommentText: "No comment",
    automaticclosingText: "To make payment, the order will be automatically closed if it expires.",
    patientText: "Dear customer, your order is being shipped out, please be patient.",
    consigneeinformationText: "Consignee Information",
    paymentinformationText: "Payment information",
    paymentmethodText: "Payment method:",
    paymenttimeText: "Payment time:",
    // 个人中心 - 我的评论
    productText: "Product",
    productdetailText: "Product Detail",
    replyblogText: "Reply to blog：",
    //收货地址
    addseliveryaddressText: "Add delivery address",
    addaddresstitleText1: "saved",
    addaddresstitleText2: ", and you can still save them",
    addaddresstitleText3: ",address",
    defaultText: "Default",
    consigneeText: "Consignee：",
    addressText: "AddressT：",
    fulladdressText: "FullAddress：",
    setdefaultText: "SetDefault",
    mobilephoneText: "Mobile：",
    viewmoreText: "View More",
    replypostText: "Reply Post：",
    // 个人中心 - 个人信息
    nameLabel: "Name",
    sexlabel: "Sex",
    modifyavatarText: "Modify Avatar",
    sexmanText: "man",
    sexwomanText: "woman",
    secrecyText: " secrecy",
    replaceText: "replace",
    saveText: "save",
    oldpasswordText: "oldPassword",
    newpasswordText: "newPassword",
    confirmpasswordText: "confirmPassword",
    opdpleasolderText: "Please enter the original password",
    newpleasolderText: "Please enter a new password",
    unboundText: "unbound",
    bindingText: "binding",
    unbindingText: "unbinding",
    // 个人中心-个人信息
    regionText: "Local area",
    addconsigneleasolderText: "Please fill in the name of the consignee",
    countrypleasolderText: "Please select country",
    provinceleasolderText: "Please select province",
    citypleasolderText: "Please select city",
    areapleasolderText: "Please select area",
    fulladdressTextpleasolderText: "Please enter the full address",
    addconsignephoneleasolderText: "Please fill in the consignee's mobile phone number",
    emailpleasolderText: "Please enter the email address",
    phoneText: 'Mobile phone number',
    uploadimgText: "Upload pictures",
    updateuserface: "Modify profile picture",
    uploadimgtitle1: "jpg, jpeg, and png images are supported",
    uploadimgtitle2: "Recommended size: 200*200 or equal scale pictures",
    updateemailText: "Modify email",
    updatemobileText: "Change mobile phone number",
    dialogemailtitle: "Email address",
    dialogmobiletitle: "Mobile phone number",
    dialogheadertitle: "The input is associated with your brocade account",
    continueText: "continue",
    verificationinformation: "Validation information",
    verificationinformationTitle1: "To proceed, complete this verification step. We have turned to",
    verificationinformationTitle2: "A verification code was sent. Please enter below.",
    verificationcode: "Verification code",
    newtitle: "new",
    dialognewmobiletitle: "Enter the new mobile number to be associated. And click Confirm replacement",
    confirmpbtnText: "confirm",
    titlecpuntryselect: "Country of choice",
    hotcountrytitle: "Hot country",
    aboutusText: "About us",
    // 订单详情
    havequestionsText: "Have questions",
    preferentialText: "preferential",
    enquiryText: "enquiry",
    fullnameText:"full name",
    combinationdiscountText: "Combination discount",
    introduceText: "introduce",
    buyermycommentsText: "Buyer myComments",
    starText: "star",
    yourmailboxText: "your mailbox",
    placeholderquestionText: "Please write down your questions",
    uploadimglimtText: "Please upload JPG/GIF/PNG file. The image size cannot exceed 2MB.",
    submitbtnText: "submit",
    // 购物车
    selectText: "select",
    tipscartsText: "Selected products (excluding freight)",
    settlementText: "settlement",
    selectallText: "select all",
    amountText: "amount",
    addtofavoritesText: "add Favorites",
    havecollectedText: "collected",
    tipdelecteproduct: "Are you sure to delete the current item?",
    deleteText: "Delete",
    tipclearcart: "Sure to empty the cart?",
    clearcartText: "empty cart",
    totalText: "Total:",
    totaltipText: "item (excluding freight):",
    pieceText: "piece",
    freightText: "Freight:",
    taxationText: "Taxation:",
    fullreductionamountText: "Full reduction amount:",
    amountpayableText: "Amount payable:",
    confirmorderText: "Confirm order",
    paymentsucceededText: "Payment succeeded",
    receivinginformationText: "Receiving information",
    othershippingaddressText: "Other shipping address",
    addshippingaddressText: "Add shipping address",
    selectshippingaddressText:"Select shipping address",
    selfprimingText: "Self priming",
    typeofshippingText: "type of shipping",
    inquirecostsText: "Click here to inquire about shipping costs",
    confirmproductinformationText:"Confirm product information",
    settlementinformationText:"Settlement information",
    clipcoupons:"Clip coupons",
    allitemsText:"All items",
    validtoText:"Valid to ",
    pieceproductTotal:"piece product Total:",
    placeorder:"place order",
    consultText:"consult",
    consultationText:"Please enter the consultation content",
    cancelText:"Cancel",
    sendoutText:"Send out",
    enterproductname:"Enter product name",
    contentText:"Content",
    filerestrictionsText:"Please upload a JPG/GIF/PNG file. The image size cannot exceed 2MB.",
    withaccountText:"Enter the email address associated with your Jinge account",
    pagelostText:"Sorry, the page you visited has been lost",
    pagelostText1:"Automatically jump to the previous page in seconds, if not, click the refresh button",
    pagelostText2:"renovate",
    pagelostText3:"Return to Home Page",
    verificationrequiredText:"Verification Required",
    continuestepemailText:"To continue, complete this verification step. We have emailed",
    sendcodeText:"A verification code was sent. Please enter below.",
    resendverificationcodeText:"Resend verification code",
    createnewpasswordText:"Create a new password",
    providepasswordText:"You will need to provide this password each time you log in.",
    savechangeText:"Save changes and log in",
  }
}





// WEBPACK FOOTER //
// ./src/assets/language/local_en.js